import http from 'hub-http/clients/apiClient';
import { registerMutation, useMutation } from 'data-fetching-client';
import { convertInternalViewToBEFormat, transformBackendViewToInternalFormat } from '../../viewsSearch/dataOperators/backendViews';
import { VIEWS_SEARCH_QUERY_NAME } from '../../viewsSearch/hooks/useFetchViewsSearch';
export const CREATE_SINGLE_VIEW_MUTATION_NAME = 'createSingleView';
const createViewMutationArgsArgument = ['objectTypeId', 'name', 'state', 'teamId', 'private', 'namespaceName', 'clonedFromViewId'];
export const CreateSingleViewMutation = registerMutation({
  fieldName: CREATE_SINGLE_VIEW_MUTATION_NAME,
  args: createViewMutationArgsArgument,
  fetcher: args => {
    const clonedFromViewIdParam = args.clonedFromViewId ? `&clonedFromViewId=${args.clonedFromViewId}` : '';
    return http.post(`/sales/v4/views?namespace=${args.namespaceName}${clonedFromViewIdParam}`, {
      //we ignore this error because we are explicitly omotting the id of the view - this is the only case this should be needed
      data: convertInternalViewToBEFormat(args, [
      // Until we have a way to set the view color, we want the auto-generated view color
      'viewColor'])
    }).then(result => {
      return transformBackendViewToInternalFormat(result);
    });
  }
});
export const useCreateSingleViewMutation = view => {
  return useMutation(CreateSingleViewMutation, {
    variables: view,
    refetchQueries: [VIEWS_SEARCH_QUERY_NAME],
    awaitRefetchQueries: true
  });
};